import React from 'react';
import PropTypes from 'prop-types';

// Component to render an individual holiday item
const DayListItem = ({ holiday }) => {
  
  const { name, day, monthShort } = holiday;

  const [maintitle , subtitle] = name.split('//').map(part=>part.trim());

  return (
    <div className="flex flex-col border-b border-gray-100 last:border-b-0">
      {/* Holiday details */}
      <div className="flex flex-row justify-between p-4">
        <div className="flex items-center">
          <h2 className="text-sm leading-sm">{maintitle}{subtitle && (
            <span className="text-sm leading-sm ml-0.5">{subtitle}</span>
          )}</h2>
        </div>
        <div className="">
        <span className="text-2xl font-bold leading-[30px]">
          {day}
          <sup className="text-xs font-normal ml-1 leading-4 relative top-[-15px]">{monthShort}</sup>
        </span>
        </div>
      </div>
      {/* Separator */}
    </div>
  );
};

// Define prop types for validation
DayListItem.propTypes = {
    holiday: PropTypes.shape({
      name: PropTypes.string.isRequired,
      day: PropTypes.number.isRequired,
      monthShort: PropTypes.string.isRequired,
    }).isRequired,
};

export default DayListItem;
